import styled, { createGlobalStyle, css } from 'styled-components';

import BREAKPOINTS from './breakpoints';
import COLORS from './colors';
import FONTS, { base } from './fonts';
import SlickSlider from './third-party/slick-slider';
import TYPO, { weight } from './typography';

export default createGlobalStyle`
  :root {
    --gutter: 20px;
    --gutter-side: 18px;
    --font-feature-settings-normal: 'pnum' on, 'lnum' on, 'ss03' on;

    --landing-has-banner: translate3d(0, 0, 0);

    ${BREAKPOINTS.custom(414)`
      --gutter-side: 27px;
    `};
  }

  html,
  body {
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: ${base}px;
    font-family: ${FONTS.poppins};
    font-feature-settings: 'ss01' on, 'ss02' on, 'ss03' on, 'ss04' on;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }

  a {
    color: inherit;
    text-decoration: underline;
    font-weight: ${weight.semibold};
    cursor: pointer;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
    font-family: ${FONTS.wulkan};
    font-feature-settings: var(--font-feature-settings-normal);
  }

  p {
    ${TYPO.p1}
    opacity: 0.8;
  }

  strong {
    font-weight: ${weight.black};
  }

  button {
    padding: 0;
    background-color: transparent;
    border: none;
    outline: none;
    cursor: pointer;
  }

  ul,
  ol {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  input,
  input[type=text],
  input[type=password],
  textarea {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
  }

  ${SlickSlider}
`;

export const BackgroundTexture = css`
  background-image: url('/images/backgrounds/bg-texture.png');
  background-size: 220px auto;
`;

export const DotsPattern = css`
  background-image: url('/images/backgrounds/bg-dots-pattern.svg');
  background-size: 54px auto;

  ${BREAKPOINTS.small`
    background-size: 63px auto;
  `}
`;

export const CircleButton = css`
  padding: 4px;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-clip: content-box;
  border: 1px solid ${COLORS.dawn.opacity(0.4)};
  border-radius: 100%;
  background-color: ${COLORS.dawn};
  transition: 0.4s;
  cursor: pointer;
`;

export const variants = {
  light: {
    bgColor: COLORS.pinkMuted,
    color: COLORS.forest,
    roundel: '/images/backgrounds/bg-roundel-dark.svg',
  },
  dark: {
    bgColor: COLORS.forest,
    color: COLORS.pinkMuted,
    roundel: '/images/backgrounds/bg-roundel-light.svg',
  },
};

export const PageContainer = styled.div`
  background-color: ${({ theme }) => variants[theme].bgColor};
  color: ${({ theme }) => variants[theme].color};
  min-height: 100vh;

  ${BREAKPOINTS.small`
    background-image: ${({ theme }) => `url(${variants[theme].roundel})`};
    background-position: -400px 400px;
    background-repeat: no-repeat;

     ${({ theme, bgRoundels }) =>
       bgRoundels === 2 &&
       css`
         background-image: url(${variants[theme].roundel}),
           url(${variants[theme].roundel});
         background-position: -400px 400px, calc(100vw - 220px) -182px;
       `}
  `}
`;

export const CircleMask = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: inherit;
  background-color: ${(props) => props.bgColor || COLORS.redWine};
  border-radius: 50vw 50vw 0 0;
  overflow: hidden;
  ${DotsPattern}

  /* Fix for overflow hidden with border-radius in Safari */
  transform: translateZ(0) translateY(1px);
`;
